// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand-primary: #1a5f7a;
  --brand-secondary: #2c88b0;
  --brand-accent: #34c4e7;
  --success-color: #27ae60;
  --warning-color: #f39c12;
  --danger-color: #e74c3c;
  --text-primary: #2c3e50;
  --text-secondary: #607d8b;
  --background-primary: #f8fafb;
  --background-secondary: #ffffff;
  --border-color: #e0e6ed;
  --shadow-sm: 0 2px 4px rgba(26, 95, 122, 0.06);
  --shadow-md: 0 4px 6px rgba(26, 95, 122, 0.1);
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 20px;
}

.login-container {
  max-width: 440px;
  margin: 40px auto;
  padding: 40px;
  background: var(--background-secondary);
  border-radius: var(--radius-lg);
  box-shadow: 0 8px 30px rgba(26, 95, 122, 0.12);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: fadeIn 0.6s ease-out;
}

.login-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.login-container h2 {
  color: var(--text-primary);
  margin-bottom: 24px;
  text-align: center;
  font-weight: 600;
}

form {
  padding: 0 15px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 0.95rem;
}

.form-group input {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 1rem;
  transition: all 0.3s ease;
  background: var(--background-primary);
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: var(--brand-accent);
  box-shadow: 0 0 0 4px rgba(52, 196, 231, 0.15);
}

.error-message {
  background-color: rgba(231, 76, 60, 0.1);
  color: var(--danger-color);
  padding: 14px;
  border-radius: var(--radius-md);
  margin-bottom: 24px;
  font-size: 0.95rem;
  text-align: center;
  border-left: 4px solid var(--danger-color);
}

button[type="submit"] {
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(135deg, var(--brand-secondary), var(--brand-primary));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 12px;
}

button[type="submit"]:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(26, 95, 122, 0.25);
}

button[type="submit"]:disabled {
  background: linear-gradient(135deg, #a0a0a0, #808080);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.forgot-password {
  text-align: center;
  margin-top: 16px;
}

.forgot-password a {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.forgot-password a:hover {
  color: var(--primary-dark);
  text-decoration: underline;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Enhanced mobile responsiveness */
@media (max-width: 768px) {
  .login-container {
    margin: 20px;
    padding: 30px;
  }

  .brand-title h1 {
    font-size: 1.8rem;
  }

  .brand-title .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .login-container {
    margin: 16px;
    padding: 24px;
  }

  .brand-title h1 {
    font-size: 1.6rem;
  }
}

/* Add to existing Login.css */
.admin-login-link {
  margin-top: 24px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.admin-login-link p {
  color: var(--text-secondary);
  margin-bottom: 12px;
  font-size: 0.9rem;
}

.switch-to-admin-btn {
  background: none;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.switch-to-admin-btn:hover {
  background: var(--primary-color);
  color: white;
  transform: translateY(-1px);
}

/* Remove the old toggle-container styles */
.toggle-container,
.toggle-button {
  display: none;
}

/* Admin toggle styles with increased specificity */
.login-container .admin-toggle {
  margin-top: 24px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.login-container .admin-toggle .admin-link {
  background: none !important;
  border: none !important;
  color: var(--text-secondary) !important;
  font-size: 0.9rem !important;
  padding: 8px 16px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  text-decoration: underline !important;
  opacity: 0.8 !important;
  box-shadow: none !important;
  transform: none !important;
}

.login-container .admin-toggle .admin-link:hover {
  color: var(--primary-color) !important;
  opacity: 1 !important;
  background: none !important;
  transform: none !important;
}

.login-container .admin-toggle .admin-link.active {
  color: var(--primary-color) !important;
  font-weight: 500 !important;
  background: none !important;
}

/* Remove any conflicting styles */
.toggle-container,
.toggle-button,
.admin-login-link,
.switch-to-admin-btn {
  display: none !important;
}

/* Brand Title Styles */
.brand-title {
  text-align: center;
  margin-bottom: 32px;
}

.brand-title h1 {
  font-size: 2.2rem;
  color: var(--brand-primary);
  margin: 0;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.brand-title .subtitle {
  color: var(--brand-secondary);
  font-size: 1.1rem;
  margin-top: 8px;
  font-weight: 500;
} `, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,8CAA8C;EAC9C,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uCAAuC;EACvC,+BAA+B;EAC/B,8CAA8C;EAC9C,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iFAAiF;EACjF,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;;EAEE,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;;;;EAIE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[":root {\n  --brand-primary: #1a5f7a;\n  --brand-secondary: #2c88b0;\n  --brand-accent: #34c4e7;\n  --success-color: #27ae60;\n  --warning-color: #f39c12;\n  --danger-color: #e74c3c;\n  --text-primary: #2c3e50;\n  --text-secondary: #607d8b;\n  --background-primary: #f8fafb;\n  --background-secondary: #ffffff;\n  --border-color: #e0e6ed;\n  --shadow-sm: 0 2px 4px rgba(26, 95, 122, 0.06);\n  --shadow-md: 0 4px 6px rgba(26, 95, 122, 0.1);\n  --radius-sm: 6px;\n  --radius-md: 12px;\n  --radius-lg: 20px;\n}\n\n.login-container {\n  max-width: 440px;\n  margin: 40px auto;\n  padding: 40px;\n  background: var(--background-secondary);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 8px 30px rgba(26, 95, 122, 0.12);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  animation: fadeIn 0.6s ease-out;\n}\n\n.login-container:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);\n}\n\n.login-container h2 {\n  color: var(--text-primary);\n  margin-bottom: 24px;\n  text-align: center;\n  font-weight: 600;\n}\n\nform {\n  padding: 0 15px;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 14px 18px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: var(--background-primary);\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--brand-accent);\n  box-shadow: 0 0 0 4px rgba(52, 196, 231, 0.15);\n}\n\n.error-message {\n  background-color: rgba(231, 76, 60, 0.1);\n  color: var(--danger-color);\n  padding: 14px;\n  border-radius: var(--radius-md);\n  margin-bottom: 24px;\n  font-size: 0.95rem;\n  text-align: center;\n  border-left: 4px solid var(--danger-color);\n}\n\nbutton[type=\"submit\"] {\n  width: 100%;\n  padding: 16px 24px;\n  background: linear-gradient(135deg, var(--brand-secondary), var(--brand-primary));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-top: 12px;\n}\n\nbutton[type=\"submit\"]:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(26, 95, 122, 0.25);\n}\n\nbutton[type=\"submit\"]:disabled {\n  background: linear-gradient(135deg, #a0a0a0, #808080);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.forgot-password {\n  text-align: center;\n  margin-top: 16px;\n}\n\n.forgot-password a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.forgot-password a:hover {\n  color: var(--primary-dark);\n  text-decoration: underline;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Enhanced mobile responsiveness */\n@media (max-width: 768px) {\n  .login-container {\n    margin: 20px;\n    padding: 30px;\n  }\n\n  .brand-title h1 {\n    font-size: 1.8rem;\n  }\n\n  .brand-title .subtitle {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-container {\n    margin: 16px;\n    padding: 24px;\n  }\n\n  .brand-title h1 {\n    font-size: 1.6rem;\n  }\n}\n\n/* Add to existing Login.css */\n.admin-login-link {\n  margin-top: 24px;\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.admin-login-link p {\n  color: var(--text-secondary);\n  margin-bottom: 12px;\n  font-size: 0.9rem;\n}\n\n.switch-to-admin-btn {\n  background: none;\n  border: 2px solid var(--primary-color);\n  color: var(--primary-color);\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.switch-to-admin-btn:hover {\n  background: var(--primary-color);\n  color: white;\n  transform: translateY(-1px);\n}\n\n/* Remove the old toggle-container styles */\n.toggle-container,\n.toggle-button {\n  display: none;\n}\n\n/* Admin toggle styles with increased specificity */\n.login-container .admin-toggle {\n  margin-top: 24px;\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.login-container .admin-toggle .admin-link {\n  background: none !important;\n  border: none !important;\n  color: var(--text-secondary) !important;\n  font-size: 0.9rem !important;\n  padding: 8px 16px !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  text-decoration: underline !important;\n  opacity: 0.8 !important;\n  box-shadow: none !important;\n  transform: none !important;\n}\n\n.login-container .admin-toggle .admin-link:hover {\n  color: var(--primary-color) !important;\n  opacity: 1 !important;\n  background: none !important;\n  transform: none !important;\n}\n\n.login-container .admin-toggle .admin-link.active {\n  color: var(--primary-color) !important;\n  font-weight: 500 !important;\n  background: none !important;\n}\n\n/* Remove any conflicting styles */\n.toggle-container,\n.toggle-button,\n.admin-login-link,\n.switch-to-admin-btn {\n  display: none !important;\n}\n\n/* Brand Title Styles */\n.brand-title {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.brand-title h1 {\n  font-size: 2.2rem;\n  color: var(--brand-primary);\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.brand-title .subtitle {\n  color: var(--brand-secondary);\n  font-size: 1.1rem;\n  margin-top: 8px;\n  font-weight: 500;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
